import React from 'react';
import { observer } from 'mobx-react';
import ExcelTableCellLabel from './CellLabel';
import ExcelTableCellSpan from './CellSpan';
import ExcelTableCellField from './cell-field';

import ExcelTableCellDetailTable from './DetailTable';
import ExcelTableCellDetailButtons from './DetailButtons';

import ExcelTableCellLink from './CellLink';
import ExcelTableCellDiv from './CellDiv';
import ExcelTableCellDetailSum from './DetailSum';
import DetailCheckAll from './cell-field/checkbox-element/DetailCheckAll';
import DetailCheckbox from './cell-field/checkbox-element/DetailCheckbox';
import ExcelTableTabTable from './TabTable';
import ModeTab from '../modeTab';

import ModeExcel, { CellProps } from '../../stores/card/ModeExcel';
import CardStore from '../../stores/card';
import ExcelTableMutilContent from './MutilContent';
import { WeaLocaleProvider } from 'ecCom';
import PortalPage from './PortalPage';
import { toJS } from 'mobx';
import jquery from "jquery";
import CellLikes from './CellLikes';
const getLabel = WeaLocaleProvider.getLabel;

export interface ExcelTableCellProps {
  cell: CellProps;
  excel: ModeExcel;
  form: any;
  card: CardStore;
  detail?: string;
  content?: string;
  contentType?: 'content' | 'index' | 'span';
  index: number;
  className?: string;

}

@observer
export default class ExcelTableCell extends React.Component<ExcelTableCellProps, any> {
  render() {
    const { cell,card,contentType,index,excel,form,className,detail,content} = this.props;
    if(cell&&(cell.evalue == "#QRCodeImg#" || cell.evalue == "#BARCodeImg#")){
      return <ExcelTableCellDiv ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableCellDiv@cft66b`}  cell={cell}  card={card}/>
    }
    /****
     * 显示布局点赞功能
     */
    if(card.base.type == '0'&&cell&&(cell.evalue == "#likes#" || cell.evalue == "#dislikes#")&& card.isallowdislike == '1'){
      return <CellLikes ecId={`${this && this.props && this.props.ecId || ''}_CellLikes@8uc030`}  cell={cell}  card={card} />
    }

    switch (cell.etype) {
      case '':
      case '0':
      case '1':
      case '4':
        return (
          <ExcelTableCellSpan ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableCellSpan@k3pdfw`}  cell={cell}  excel={excel} contentType={contentType}
            form={form}
            card={card}
            index={index}
          />
        )
      case '6':
        ////文本、节点名称、图片
        return <span></span>
      case '2':
        ////字段名
        return <ExcelTableCellLabel ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableCellLabel@3jje5q`}  form={form} cell={cell} card={this.props.card} />
      case '3':
        ////字段值
        return <ExcelTableCellField ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableCellField@ujil20`} cell={cell} form={form} card={card}  excel={excel}  index={index} />
      case '7':
        ////明细
         return <ExcelTableCellDetailTable ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableCellDetailTable@rpigwa`} cell={cell} card={this.props.card} />
      case '10':
        ////明细操作按钮
        return <ExcelTableCellDetailButtons ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableCellDetailButtons@gb2zn5`} card={card}  excel={excel}  />
      case '11':
        ////链接
        return <ExcelTableCellLink ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableCellLink@q7l7a3`} cell={cell} />
      case '12':
        ////标签页
        return <ExcelTableTabTable ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableTabTable@fr9pxt`} card={card}  cell={cell}  />
      case '13':
        ////多内容
        return <ExcelTableMutilContent ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableMutilContent@si0fy9`}  
            cell={cell}
            excel={excel}
            contentType={contentType}
            form={form}
            card={card}
            index={index}
            detail={detail}
            content={content}
            className={className}
        />
      case '14':
        ////多内容换行
        if (cell.brsign == 'Y') {//换行
          return <br />
        } else {
          return null;
        }
      case '15':
        //////门户元素
        const jsonparam = toJS(cell.jsonparam) || {};
        const hpid = jsonparam.hpid || "";
        let formData = {}
        if(hpid!=''&&jsonparam.trifields){
          const {form} = this.props;
          const trifields=jsonparam.trifields||"";
          trifields.split(",").map(fieldid =>{
            const bindObj =form.has(fieldid) ? form.$(fieldid) : {};
            if(!jquery.isEmptyObject(bindObj)){
              const bind = bindObj.bind();
              let fieldValue=bind.value;
              formData[fieldid] = fieldValue;
            }
          })
          formData["_billid"]=this.props.card.base.billid;
        }
        return <PortalPage ecId={`${this && this.props && this.props.ecId || ''}_PortalPage@y4vty8`} hpid={hpid} formData={formData} />
      case '16':
      case '17':
        //////iframe区域、扫码区
        return <ExcelTableCellDiv ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableCellDiv@ghyr2q`}    cell={cell}   card={card} />
      case '18':
        ////合计名称
        return (
          <ExcelTableCellSpan ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableCellSpan@90lifg`} 
            cell={cell}
            excel={excel}
            form={form}
            card={card}
            index={index}
            content={`(${getLabel('358','合计')})`} contentType='content' 
          />
        )
      case '19':
        ////合计值
        return (
          <ExcelTableCellDetailSum ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableCellDetailSum@rifaq3`}   cell={cell} form={form} card={card}   />
        )
      case '20':
        ////明细全选
        return (
          <DetailCheckAll ecId={`${this && this.props && this.props.ecId || ''}_DetailCheckAll@jvs6hp`}  detail={detail}  excel={excel} form={form}  card={card} />
        )
      case '21':
        ////明细单选
        return (
          <DetailCheckbox ecId={`${this && this.props && this.props.ecId || ''}_DetailCheckbox@qn5zfi`}  detail={detail} excel={excel} form={form}  card={card}   />
        )
      case '22':
        ////序号
        return (
          <ExcelTableCellSpan ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableCellSpan@3kzszj`} cell={cell}  excel={excel} form={form}  card={card} index={index} contentType='index' />
        )
      case '23':
        let parm = this.props.card.params;
        let istagset = this.props.card.base.istagset;
        if (istagset == '1') {
          ////标签
          return (
            <ModeTab ecId={`${this && this.props && this.props.ecId || ''}_ModeTab@frvt99`} container="#container" modeid={parm.modeId} billid={parm.billid}  type={'card'} />
          )
        } else {
          return (<div style={{ color: 'red' }}>{getLabel(385121, '请联系管理员后台开启标签功能!')}</div>)
        }
      case '8':
        return null;

    }
    return (
      <div>{cell.evalue}</div>
    )
  }

}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/TableCell.tsx